/**
 * @description 登录、获取用户信息、退出登录、清除token逻辑，不建议修改
 */
import { defineStore } from 'pinia'
import { getConfig, getAppConfig, getThemeConfig } from '@/api/config'
import { getUrlKey, removeUrlHashParameter } from '@/utils/'
import { useCssVar } from '@vueuse/core'
import { ref } from 'vue'
import { getArea } from '@/api/common'
import { Storage } from '@/utils/storage'

import { useUserStore } from '@/store/modules/user'

export const useAppStore = defineStore('app', {
  state: () => {
    return {
      config: {},
      event: {},
      platform: 'desktop',
      track: '',
      area: [],
      openid: '',
      isWeixin: window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger',
    }
  },
  getters: {
    //主题
    template: (state) => (state.event && state.event.Config && state.event.Config.Template === '2' ? '2' : '1'),

    mobile: (state) => state.platform === 'mobile',
  },
  actions: {
    loadConfig() {
      return new Promise(async (resolve, reject) => {
        let v = getUrlKey('v')
        let i = getUrlKey('i')
        if (!(v || i)) {
          console.error('无活动参数v')
          reject()
          return
        }
        const { data: area } = await getArea()
        this.area = Object.freeze(area)
        const { data: e } = await getConfig({ v: v, i: i })
        this.event = e
        const { data: c } = await getAppConfig({ v: v, i: i })
        this.config = c
        const { data: theme } = await getThemeConfig({ v: v, i: i })
        //
        if (theme && theme.css) {
          for (var g in theme.css) {
            useCssVar(g, ref(null)).value = theme.css[g]
          }
        }
        const getOpenID = true
        if (this.isWeixin && getOpenID) {
          this.openid = Storage.get(e.EventID, 'openid') //获取当前openid // "1234567890";
          if (!this.openid) {
            var $openid = getUrlKey('openid')
            var $timestamp = getUrlKey('timestamp')
            var ts = Storage.get(e.EventID, 'timestamp') // Local.get("timestamp");
            if ($openid && ts && $timestamp && ts == $timestamp) {
              this.openid = $openid
              Storage.set(e.EventID, 'openid', $openid, 300) //保存
              Storage.remove(e.EventID, 'timestamp') //删除当前请求的授权值
              var redirect_uri = removeUrlHashParameter(window.location.href, ['openid', 'timestamp'])
              console.log('redirect_uri', redirect_uri, window.location.href)
              window.location.href = redirect_uri //hash模式下，路由不会触发
            } else {
              var timestamp = new Date().getTime()
              Storage.set(e.EventID, 'timestamp', timestamp, 30) //30秒内有效
              var redirect_uri = removeUrlHashParameter(window.location.href, ['openid', 'timestamp'])
              redirect_uri = redirect_uri + (redirect_uri.indexOf('?') >= 0 ? '&' : '?') + 'timestamp=' + timestamp
              redirect_uri = 'https://www.dataleading.cn/wechartapi/openid.ashx?state=OpenID&Redirect=' + encodeURIComponent(redirect_uri)
              window.location.href = redirect_uri
              return
            }
          }
        }
        //

        if (e.Config.HideIndex && e.Steps && ((e.Steps.length > 0 && e.Steps[0] == 'personal') || (e.Steps.length > 1 && e.Steps[0] == 'login' && e.Steps[1] == 'personal'))) {
          let hash = window.location.href.split('#')[1]
          let path = hash.split('?')[0]
          if (path == '/') {
            window.location.href = hash = window.location.href.split('#')[0] + '#/personal?' + hash.split('?')[1]
          }
        }
        resolve()
      })
    },
    setPlatform(value) {
      this.platform = value
      console.log('setPlatform', value)
    },
  },
})
